import { render } from "./LocaleSelect.vue?vue&type=template&id=d72624f6&scoped=true"
import script from "./LocaleSelect.vue?vue&type=script&lang=js"
export * from "./LocaleSelect.vue?vue&type=script&lang=js"

import "./LocaleSelect.vue?vue&type=style&index=0&id=d72624f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d72624f6"]])

export default __exports__